angular.module('Directives')
    .directive('bbaSwitch',

        function(toastr){
            return {
                restrict: 'E',
                templateUrl: '/templates/directives/bbaSwitch.html',
                replace: true,
                scope: {
                    name: '@',
                    ngModel: '=?',
                    disabled: '=?',
                    labels: '=',
                    onChange: '&',
                    onClick: '&?',
                    tooltipInfo: '@',
                    tooltip: '@'
                },
                link: bbaSwitchLink
            }

            function bbaSwitchLink($scope, $element, $attrs){
                $scope.testAffix = $attrs.name;
            };
        });


// WEBPACK FOOTER //
// ./js/directives/bbaSwitch.js